import axios from "../api/axios";

export type PaymentStatus = "paid" | "waiting" | "expired" | "cancelled";

// Konsultasi yang sudah checkout ke Duitku tapi belum dibayar.
export interface PendingPayment {
  teleconsult_id: number;
  teleconsult_status: string;
  payment_status: PaymentStatus;
  doctor_assign_status: "assigned" | "unassigned";
  practitioner_role_id: number | null;
  doctor_name: string | null;
  total: number;
  payment_method: string | null;
  payment_code: string | null;
  va: string | null;
  payment_url: string | null;
  expired_date: string | null;
  // Sisa waktu bayar menurut jam server (detik).
  remaining_seconds: number;
  enc_token: string;
}

export const getPendingPayment = async (token: string) => {
  try {
    const res = await axios.get("teleconsult/pending-payment", {
      headers: { Authorization: `Bearer ${token}` },
    });

    return (res.data.data ?? null) as PendingPayment | null;
  } catch (err: any) {
    // Endpoint ini hanya ada di API Vale. API hospital lain: anggap tidak ada tagihan.
    if (err.response?.status === 404 || err.response?.status === 405) return null;
    throw err;
  }
};

export const getPaymentStatus = async (teleconsultId: string | number, token: string) => {
  const res = await axios.get(`teleconsult/${teleconsultId}/payment-status`, {
    headers: { Authorization: `Bearer ${token}` },
  });

  return res.data.data as PendingPayment;
};

export const cancelPendingPayment = async (teleconsultId: string | number, token: string) => {
  const res = await axios.post(`teleconsult/${teleconsultId}/cancel-payment`, {}, {
    headers: { Authorization: `Bearer ${token}` },
  });

  return res.data;
};
